// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__CSzUy","name":"UserMenu_name__do-tN","button":"UserMenu_button__Az8kg"};